export enum NotificationPreviewRequestType {
    SET_DUE_DATE = 1,
    REMINDER = 2,
    REMOVE_DUE_DATE = 3,
}
